import yahooEmailImage from '../../../../images/yahoo-mail.svg';
import gmailImage from '../../../../images/google-mail.svg';
import icloudImage from '../../../../images/icloud-mail.svg';
import outlookImage from '../../../../images/outlook-mail.svg';
import aolImage from '../../../../images/aol-mail.svg';

export const emailClients = [
  {
    domains: ['gmail.com'],
    imageUrl: gmailImage,
    name: 'Google',
    trackingEvent: 'trials.userInviteExists.googleClicked',
    url: 'https://mail.google.com/mail/u/0/#search/no-reply%40podium.com',
  },
  {
    domains: ['yahoo.com', 'rocketmail.com', 'ymail.com'],
    imageUrl: yahooEmailImage,
    name: 'Yahoo',
    trackingEvent: 'trials.userInviteExists.yahooClicked',
    url: 'https://mail.yahoo.com/d/search/keyword=no-reply%2540podium.com',
  },
  {
    domains: [
      'icloud.com',
      'me.com',
      'mac.com',
      'icloud.de',
      'icloud.fr',
      'icloud.es',
    ],
    imageUrl: icloudImage,
    name: 'iCloud',
    trackingEvent: 'trials.userInviteExists.icloudClicked',
    url: 'https://www.icloud.com/mail/',
  },
  {
    domains: [
      'outlook.com',
      'live.com',
      'hotmail.com',
      'msn.com',
      'passport.com',
      'passport.net',
    ],
    imageUrl: outlookImage,
    name: 'Microsoft Exchange',
    trackingEvent: 'trials.userInviteExists.outlookClicked',
    url: 'https://outlook.live.com/mail/0/',
  },
  {
    domains: ['aol.com', 'love.com', 'ygm.com', 'games.com', 'wow.com'],
    imageUrl: aolImage,
    name: 'AOL',
    trackingEvent: 'trials.userInviteExists.aolClicked',
    url: 'https://mail.google.com/mail/u/0/#search/no-reply%40podium.com',
  },
];
